@file:OptIn(FlowPreview::class)

package com.wintermar.inspection.feature.presentation.inspection.answer.widget.notes

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.input.InputText
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.debounce

@Composable
fun Notes(
    notes: String,
    title: String = "",
    checkValidation: Boolean = false,
    countTriggerValidation: Int = 0,
    onValueChanged: (String) -> Unit = {},
    onResult: (value: String, isError: Boolean) -> Unit = { _, _ -> }
) {
    val padding = LocalAppTheme.current.dimension.spacing.space4
    val scope = rememberCoroutineScope()
    val inputState = remember {
        var initInputData = InputStateModel(
            value = notes,
            multiLine = true,
            placeholder = "Type your notes..."
        )
        if (checkValidation) initInputData = initInputData.defaultMandatory(
            showAsterisk = false,
            mandatoryMessage = "$title cannot be empty"
        )

        InputState(
            initialData = initInputData,
            scope = scope
        )
    }

    LaunchedEffect(inputState) {
        snapshotFlow { inputState.value.text }
            .debounce(200)
            .collectLatest {
                onValueChanged(it.toString())
            }
    }

    LaunchedEffect(countTriggerValidation) {
        if (!checkValidation || countTriggerValidation == 0) return@LaunchedEffect

        inputState.validate()
        onResult(inputState.value.text.toString(), inputState.isError)
    }

    Column(
        modifier = Modifier.fillMaxWidth()
            .padding(
                start = padding,
                end = padding,
                bottom = if (!inputState.isError) 0.dp else padding
            )
    ) {
        InputText(
            state = inputState,
            modifier = Modifier.fillMaxWidth()
        )
    }
}
